import { createSlice } from '@reduxjs/toolkit';
import type {PayloadAction} from "@reduxjs/toolkit"

export interface IMaterialsState {
	materials: { [key: string]: { [key: string]: any } };
	submitted: {
		id: string | null,
		property: string | null,
		value: any
	};
}

const initialState: IMaterialsState = {
	materials: {},
	submitted: {
		id: '',
		property: '',
		value: undefined
	},
};

const MaterialsSlice = createSlice({
	name: "materials",
	initialState: initialState,
	reducers: {
		addMaterial(state, action: PayloadAction<{ id: string, value: any, hidden: boolean }>)
		{
			state.materials[action.payload.id] = action.payload.value;
			state.materials[action.payload.id].hidden = action.payload.hidden;
		},
		removeMaterial(state, action: PayloadAction<{ id: string }>)
		{
			delete state.materials[action.payload.id];
		},
		hideMaterial(state, action: PayloadAction<{ id: string }>)
		{
			state.materials[action.payload.id].hidden = true;
		},
		unhideMaterial(state, action: PayloadAction<{ id: string }>)
		{
			state.materials[action.payload.id].hidden = false;
		},
		clearMaterials(state, action: PayloadAction<undefined>)
		{
			state.materials = {};
		},
		setMaterialProperty(state, action: PayloadAction<{ id: string, property: string, value: any, shouldSubmit?: boolean }>) // TODO: constrain 'value' types? I imagine it would be mostly string | number
		{
			const { id, property } = action.payload;

			if(!state.materials[action.payload.id]) return;
			if(!state.materials[action.payload.id][property]) state.materials[action.payload.id][property] = {}; // TODO: verify if this is legal. are we constrained by certain property names?

			state.materials[id][property].value = action.payload.value;
			state.materials[id][property].shouldSubmit = (action.payload.shouldSubmit !== undefined) ? action.payload.shouldSubmit : true;
		},
		setMaterialPropertyVisiblity(state, action: PayloadAction<{ id: string, property: string, value: boolean }>)
		{
			const { id, property } = action.payload;

			if(!state.materials[id]) return;
			state.materials[id][property].visible = action.payload.value;
		},
		submitMaterial(state, action: PayloadAction<{ id: string | null, property: string | null }>)
		{
			const { id, property } = action.payload;

			// Set default values for submitted
			state.submitted = {
				id: null,
				property: null,
				value: null
			};

			// Update only if both id and property are present
			if (id && property)
			{
				state.submitted = {
					id,
					property,
					// Simplified retrieval of the value with optional chaining and nullish coalescing
					value: state.materials[id]?.[property]?.value ?? null
				};
			}

		},
	},
});

export default MaterialsSlice;
